import React from "react";

const WriteUp = props => {
  return (
    <div className="portfolio-text">
      <h3 className="heading-tertiary u-margin-bottom-small">{props.title}</h3>
      <p className="paragraph portofolio-write-up">{props.description}</p>
    </div>
  );
};

export default WriteUp;



// WEBPACK FOOTER //
// ./src/components/sections/Section-About/WriteUp.js